import { IListManager, IPaginate } from "../../interfaces/utils.interface";
import { ListAction } from "../../helpers/enums";
import { ListEventArgs } from "./list-utils";
import { Page, RequestSetting } from "../../helpers/response";
import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "list-template",
  templateUrl: "./list-template.component.html"
})
export class ListTemplateComponent implements IListManager<any>, IPaginate {
  @Input()
  showPagination = true;
  @Input()
  showToolbar = true;
  @Input()
  showHeader = true;
  @Input()
  showAddButton = true;
  @Input()
  showCardLayout = true;
  @Input()
  listTitle = "Lista";
  /**
   *Optiene o establece la etiqueta para el botÃ³n que activa el
   modo de inserciÃ³n de un nuevo registro
   *
   * @memberof ListTemplateComponent
   */
  @Input()
  addButtonLabel = "Agregar nuevo";
  @Input()
  addButtonIcon = "fa fa-plus";
  @Input()
  requestSetting = new RequestSetting();
  @Input()
  classBtnAdd = "btn-primary";
  @Input()
  classWrapBtnAdd = "col-md-2";
  //Inputs Pagination
  @Input()
  pgRowsPerPage: number[] = [];
  @Input()
  pgMaxSize = 4;
  @Input()
  pgBoundaryLinks = true;
  @Input()
  pgPreviousText = "&lsaquo;";
  @Input()
  pgNextText = "&rsaquo;";
  @Input()
  pgFirstText = "&laquo;";
  @Input()
  pgLastText = "&raquo;";
  @Input()
  pgShowTotalRows = true;

  @Output()
  onActionChange = new EventEmitter();

  add() {
    this.onActionChange.emit(new ListEventArgs(ListAction.Add));
  }

  edit(model: any) {
    this.onActionChange.emit(new ListEventArgs(ListAction.Edit, model));
  }

  delete(model: any) {
    this.onActionChange.emit(new ListEventArgs(ListAction.Delete, model));
  }

  refresh() {
    this.onActionChange.emit(new ListEventArgs(ListAction.Refresh));
  }

  onPaginate(page: Page) {
    this.onActionChange.emit(new ListEventArgs(ListAction.Paginate));
  }
}
